import Vue from "vue";
import VueAnalytics from 'vue-analytics'
import router from "@/router";

export let ga = () => {
  if (process.env.NODE_ENV === "production") {
    Vue.use(VueAnalytics, {
      id: 'UA-96401752-9',
      router,
      set: [
        {field: 'anonymizeIp', value: true},
        {field: "dimension1", value: 'staging'/*config.slug*/} // TODO setup analytics per client
      ]
    })
  }
}
